import {
    type LinkOptions,
    type RegisteredRouter,
    linkOptions as tanstackLinkOptions,
    type ValidateLinkOptions,
} from '@tanstack/react-router';

declare const linkBrand: unique symbol;
/** Exported because, with `composite`, an exported function returning `linkOptions(…)` has to name the brand. */
export type LinkBrand = { readonly [linkBrand]: 'build this with linkOptions()' };

/** Options checked by {@link linkOptions}, so `search` can be `unknown`; a plain object could forget `params`. */
export type AppLinkOptions = Omit<LinkOptions, 'search'> & { search?: unknown } & LinkBrand;

/** Checks and brands options where written; not `T & AppLinkOptions`, whose `href?: string` breaks a link spread. */
export function linkOptions<const T>(options: ValidateLinkOptions<RegisteredRouter, T>): T & LinkBrand {
    return tanstackLinkOptions(options as never) as unknown as T & LinkBrand;
}

/** Casts stored options for a `linkable` spread, whose link branch rejects their wide `to`; no `to` becomes `'.'`. */
export function asLinkProps(options: AppLinkOptions): { to: '.' } {
    // Without one, `linkable` renders plain and passes the router props to the DOM; `'.'` is the current route.
    if (options.to === undefined) {
        return { ...options, to: '.' } as unknown as { to: '.' };
    }
    return options as unknown as { to: '.' };
}
